import { preview } from '@/components/form/preview'
import { Tooltip } from '@/components/primitives/Tooltip'

import { useTerritoryNames } from '../hooks/useTerritoryNames'
import { useTexts } from './hooks/useTexts'

import { Companies } from './Companies'
import { CourierConfig } from './CourierConfig'
import { Territories } from './Territories'

type Props = {
  user: uui.domain.client.rm.RouteManagerUser
}

export function ViewDetails(props: Props) {
  const { user } = props
  const texts = useTexts()
  const territoryNames = useTerritoryNames()

  const usernameTooltipDisabled = user.username.length < 32
  const emailTooltipDisabled = user.email.length < 32
  const role = `${user.type[0].toUpperCase()}${user.type.substring(1)}`

  return (
    <>
      <preview.Field label={texts.labels.name} testId="name" data-trackid="name">
        {user.name}
      </preview.Field>

      <preview.Field label={texts.labels.surname} testId="surname" data-trackid="surname">
        {user.surname}
      </preview.Field>

      <preview.Field label={texts.labels.email} data-trackid="email" testId="email">
        <Tooltip placement="top" disabled={emailTooltipDisabled} title={user.email} maxWidth={600}>
          <>{user.email}</>
        </Tooltip>
      </preview.Field>

      <preview.Field label={texts.labels.username} data-trackid="username" testId="username">
        <Tooltip
          placement="top"
          disabled={usernameTooltipDisabled}
          title={user.username}
          maxWidth={600}
        >
          <>{user.username}</>
        </Tooltip>
      </preview.Field>

      <preview.Divider />

      <preview.Field label={texts.labels.role} data-trackid="role" testId="role">
        {role}
      </preview.Field>

      <Companies isCompanyFiltered={user.isCompanyFiltered} companyIds={user.companies} />

      {user.type !== 'courier' && <Territories territoryFilter={user.territoryFilter} />}

      {user.type === 'courier' && (
        <CourierConfig courierFilter={user.courierFilter} territoryNames={territoryNames} />
      )}
    </>
  )
}
